<div
  *ngIf="visiblePopups().length"
  class="iap-host pointer-events-none fixed top-20 z-[1002] w-[min(100%,24rem)] ltr:right-4 rtl:left-4"
  aria-live="polite"
>
  <div class="pointer-events-auto flex flex-col gap-3">
    <article
      *ngFor="let item of visiblePopups(); trackBy: trackById"
      class="iap-card relative overflow-hidden rounded-xl border border-white-light/80 bg-white shadow-[0_8px_24px_rgba(0,0,0,0.12)] dark:border-white/10 dark:bg-[#0e1726] dark:shadow-[0_8px_28px_rgba(0,0,0,0.4)]"
    >
      <div class="iap-accent pointer-events-none absolute inset-y-0 left-0 w-1"></div>

      <div class="relative z-[1] p-4 ps-5">
        <div class="mb-1 flex items-start justify-between gap-2">
          <div class="min-w-0 flex-1">
            <p class="m-0 text-[10px] font-bold uppercase tracking-wide text-primary">Security</p>
            <h2 class="m-0 mt-0.5 text-sm font-semibold text-black dark:text-white-light">
              {{ item.title }}
            </h2>
          </div>
          <button
            type="button"
            class="iap-close -me-1 -mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded text-white-dark/60 transition hover:bg-black/5 hover:text-black dark:hover:bg-white/10 dark:hover:text-white-light"
            (click)="dismiss(item.id, $event)"
            aria-label="Dismiss notification"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          </button>
        </div>

        <p class="m-0 text-xs leading-relaxed text-white-dark dark:text-gray-400">
          <ng-container *ngIf="item.impersonatorName || item.impersonatorEmail; else fallbackMessage">
            <span class="font-medium text-black dark:text-white-light">{{ item.impersonatorName || 'An administrator' }}</span>
            <span *ngIf="item.impersonatorEmail"> ({{ item.impersonatorEmail }})</span>
            is requesting to impersonate your account
            <ng-container *ngIf="item.workspaceName">
              in <span class="font-medium text-black dark:text-white-light">{{ item.workspaceName }}</span>
            </ng-container>.
            Share this code only if you approve.
          </ng-container>
          <ng-template #fallbackMessage>{{ item.message }}</ng-template>
        </p>

        <div class="mt-3 rounded-lg bg-black/[0.04] px-3 py-2.5 text-center dark:bg-white/5">
          <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-white-dark dark:text-gray-400">
            Approval code
          </p>
          <p class="m-0 mt-1 font-mono text-2xl font-bold tracking-[0.35em] text-black dark:text-white-light">
            {{ item.code }}
          </p>
          <p class="m-0 mt-1 text-[11px] text-white-dark dark:text-gray-500">
            {{ remainingLabel(item) }}
          </p>
        </div>

        <div class="mt-3 flex gap-2">
          <button
            type="button"
            class="btn btn-outline-danger flex-1 rounded-lg px-3 py-2 text-xs font-semibold"
            [disabled]="denyingRequestId() === item.requestId"
            (click)="onDeny(item, $event)"
          >
            {{ denyingRequestId() === item.requestId ? 'Denying…' : 'Deny request' }}
          </button>
        </div>
      </div>
    </article>
  </div>
</div>
